import { useState } from 'react';
import { ModalSubmitDialog } from '../../components/modalSubmitDialog.tsx';


interface Props {
    isOpen: boolean;
    currentCount: number;
    /** Returns how many parts beyond the given count have at least one filled value. */
    filledBeyondCount: (count: number) => number;
    onCancel: () => void;
    onSubmit: (newCount: number) => void;
}

export function EditPartCountDialog({
    isOpen,
    currentCount,
    filledBeyondCount,
    onCancel,
    onSubmit,
}: Props) {
    const [inputValue, setInputValue] = useState(String(currentCount));

    const parsedCount = parseInt(inputValue, 10);
    const isValid = !isNaN(parsedCount) && parsedCount >= 1;
    const wouldRemoveFilled = isValid && parsedCount < currentCount
        ? filledBeyondCount(parsedCount)
        : 0;

    if (!isOpen) return null;
    return (
        <ModalSubmitDialog
            isOpen={isOpen}
            onCancel={onCancel}
            onSubmit={() => isValid && onSubmit(parsedCount)}
            submitButtonText='Apply'
        >
            <h3 style={{ marginTop: 0 }}>Edit part count</h3>

            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Number of parts:
                <input
                    type='number'
                    min={1}
                    value={inputValue}
                    onChange={e => setInputValue(e.target.value)}
                    style={{ width: '80px' }}
                    autoFocus
                />
            </label>

            {wouldRemoveFilled > 0 && (
                <p className='warning' style={{ marginTop: '10px' }}>
                    Changing part count to {parsedCount} would remove already filled
                    measurements for {wouldRemoveFilled} part{wouldRemoveFilled !== 1 ? 's' : ''}.
                    Are you sure you want to do this?
                </p>
            )}
        </ModalSubmitDialog>
    );
}
